import KeenSlider, { TOptionsEvents } from 'keen-slider';
import { useKeenSlider } from 'keen-slider/react';
import React, { forwardRef, useEffect } from 'react';

import mergeRefs from '../utils/mergeRefs';
import { StyledTabsPanelsContainer } from './styles';

interface TabsPanelProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
  selected: number;
  onChange?(index: number): void;
  onMounted?(slider: KeenSlider): void;
  onCreated?(slider: KeenSlider): void;
  breakpoints?: {
    [key: string]: Omit<TOptionsEvents, 'breakpoints'>;
  };
}

const TabsPanels = forwardRef<HTMLDivElement, TabsPanelProps>(
  (
    { children, selected, onChange, onMounted, onCreated, breakpoints },
    ref
  ) => {
    const [sliderRef, slider] = useKeenSlider<HTMLDivElement>({
      slidesPerView: 1,
      spacing: 15,
      loop: false,
      mode: 'snap',
      afterChange: (s) => {
        if (onChange) onChange(s.details().relativeSlide);
      },
      mounted: (s) => {
        if (onMounted) onMounted(s);
      },
      created: (s) => {
        if (onCreated) onCreated(s);
      },
      breakpoints
    });

    useEffect(() => {
      if (slider) slider.moveToSlide(selected);
    }, [selected, slider]);

    return (
      <StyledTabsPanelsContainer ref={mergeRefs([ref, sliderRef])}>
        {React.Children.map(children, (child) => {
          if (!React.isValidElement(child)) return;
          return React.cloneElement(child);
        })}
      </StyledTabsPanelsContainer>
    );
  }
);

export default TabsPanels;
